import { type SegmentAction, triggerSegmentAction } from '@/src/services/segment'
import { type ComponentRef, forwardRef, type ComponentProps, type PropsWithChildren } from 'react'
import { ImageBackground, StyleSheet, TouchableOpacity } from 'react-native'

export const SquareCard = forwardRef<
  ComponentRef<typeof TouchableOpacity>,
  {
    image?: string
    background?: string | false
    segmentAction?: SegmentAction
  } & PropsWithChildren &
    Pick<ComponentProps<typeof TouchableOpacity>, 'style' | 'onPress' | 'testID'> & {
      imageBackgroundStyle?: ComponentProps<typeof ImageBackground>['style']
    }
>(({ image, background, children, segmentAction, style, imageBackgroundStyle, ...props }, ref) => {
  const onPress =
    (props.onPress || segmentAction) &&
    ((...args: Parameters<NonNullable<typeof props.onPress>>) => {
      props.onPress?.(...args)
      segmentAction && void triggerSegmentAction({ component: 'Card', action: segmentAction })
    })

  return (
    <TouchableOpacity
      {...props}
      ref={ref}
      onPress={onPress}
      disabled={!onPress}
      style={StyleSheet.flatten([
        (background || background === false) && [
          styles.simpleCard,
          background && { backgroundColor: background },
        ],
        style,
      ])}
    >
      {background || background === false ? (
        children
      ) : (
        <ImageBackground
          style={[styles.simpleCard, imageBackgroundStyle]}
          imageStyle={styles.imageStyle}
          source={image || require('@/src/assets/images/card-background.png')}
        >
          {children}
        </ImageBackground>
      )}
    </TouchableOpacity>
  )
})

const styles = StyleSheet.create({
  simpleCard: { minHeight: 300, padding: 5, borderRadius: 16 },
  imageStyle: { borderRadius: 16 },
})
